import Action from '../../classes/Action';
import {ActionDescription, ActionParameters}   from '../../classes/api/APIDecorators';
import ScenarioHealthUtils from "../../classes/utilities/ScenarioHealthUtils";
import store, { StoreActions } from '../../state/store';
import {UISubcomponentPropertyValue, UITemplateData} from "../../interfaces/UITemplateData";
import {RegisterActionWithAPI} from "../../classes/api/Decorators";

@ActionDescription( "Modifies a UI property. Returns void")
@ActionParameters({templateData: "UITemplateData", previousValue: "string"})
@RegisterActionWithAPI("UIEditorValueChangeAction")
export default class UIEditorValueChangeAction extends Action
{
	constructor(templateData: UITemplateData, previousValue: UISubcomponentPropertyValue = "")
	{
		const previousData = { ...templateData,
			property: {
				...templateData.property,
				value: previousValue
			}
		};

		super(
			[templateData],
			[previousData],
			`Set UI Property ${templateData.property.name} to ${templateData.property.value}`,
			[templateData, previousData]
		);
	}

	do(templateData: UITemplateData)
	{
		store.dispatch(StoreActions.ui.setProperty(templateData));
		if(templateData.subcomponent === "Insets") ScenarioHealthUtils.CheckInsetsReferences();
	}

	undo(previousData: UITemplateData)
	{
		if (previousData.property.changed === false)
		{
			delete previousData.property.changed;
		}
		store.dispatch(StoreActions.ui.setProperty(previousData));
		if(previousData.subcomponent === "Insets") ScenarioHealthUtils.CheckInsetsReferences();
	}

	verify(templateData: UITemplateData, previousData: UITemplateData)
	{
		if (!templateData) return false;
		const stepData = store.getState().uiModule.ui[templateData.step];
		if ( !stepData) return false;
		if (templateData.property.changed !== false)
		{
			const propertyName = templateData.property.name;
			if(!propertyName) return false;

			//if it crashes on the next line strengthen the null checks.
			if (!stepData[templateData.template]?.[templateData.subcomponent]?.[propertyName]) return true;
			if (stepData &&
				stepData[templateData.template][templateData.subcomponent][propertyName].value === templateData.property.value &&
				previousData.property.value === templateData.property.value)
			{
				console.log('returning false');
				return false;
			}
		}
		return true;
	}
}
